import angular from 'angular';
import AdvertisementComponent from './advertisement.component';

let AdvertisementModule = angular.module('home.advertisement',[])
    .component('advertisement',AdvertisementComponent);

export default AdvertisementModule;


/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/shared/components/advertisement/advertisement.js
 **/